import React, { lazy, Suspense, useEffect } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Link, useHistory, useRouteMatch } from 'react-router-dom';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from 'react-share';

import { ReactComponent as ShoppingCart } from 'assets/icons/shopping_cart.svg';

import Button from 'components/button';
import DropdownMenu from 'components/dropdown';
import { Row, Column } from 'components/grid';
import { Interpunct } from 'components/card/elements';
import Loader from 'components/loader';
import Container from 'components/container';

import { TabsWrapper, MainImage } from 'containers/EventItemPage/elements';
import { SocialMedia, Share } from './elements';

import { useStateValue } from 'context/store';
import { playSong, playAlbum, setMusicCurrency } from 'context/player/actions';

import { extractContent2 } from 'utils';
// import { scrollToTop } from 'utils/browserUtil';
import { useFetch } from 'utils/hooks';
import { trackViewContent } from 'utils/analyticsUtil';

import {
  Details,
  Header,
  Table,
  Title,
  Tr,
  MoreAlbums,
  Play,
  PlayButton,
  Th,
  Td
} from './elements';
import { DIGITAL_CONTENT_ITEM_STORE } from 'constants.js';
import {
  addToCart,
  totalCost,
  openCart,
  closeCart,
  updateCurrency
} from 'context/cart/actions';
import { CartButton } from 'components/cart/elements';
import { openGallery } from 'context/gallery/actions';
import MetaHelmet from 'components/MetaHelmet';
import Dock from 'components/dock';
import { currencies } from 'containers/EventItemPage/constants';
import DropDownSelect from 'components/dropdownSelect';
import Description from 'components/description';
import useToast from 'components/toast';

const DigitalContentCard = lazy(() =>
  import(
    /* webpackChunkName: "DigitalContentCard" */ 'components/card/DigitalContentCard'
  )
);

const NotFoundPage = lazy(() =>
  import(/* webpackChunkName: "NotFoundPage" */ 'containers/NotFoundPage')
);

function MobilePage({ res, loading, error }) {
  const { prices, store, thumbnail, tracks } = res;
  const {
    state: { player, cart },
    dispatch
  } = useStateValue();

  const toast = useToast();
  const { musicCurrency } = player;
  const { path } = useRouteMatch();
  const history = useHistory();

  useEffect(() => {
    // scrollToTop();
    trackViewContent(res);
    // eslint-disable-next-line
  }, [res.slug]);

  const [stores] = useFetch(
    [],
    `${DIGITAL_CONTENT_ITEM_STORE}/?store=${store.id}`,
    {
      method: 'GET'
    },
    'album_stores'
  );

  const newImg = new Image();
  newImg.src = thumbnail;

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <NotFoundPage />;
  }

  const filteredStores = stores.filter(album => album.id !== res.id);
  console.log(cart.currencyValue);

  function handleAddToCart() {
    if (cart.items.length && cart.currencyValue !== musicCurrency) {
      console.log('toast0');
      toast({
        title: 'Warning!',
        description: 'You cannot add multiple currencies in the cart',
        status: 'warning',
        position: 'bottom-left',
        duration: 9000,
        isClosable: true
      });
    } else {
      console.log('toast1');
      dispatch(addToCart(res));
      dispatch(openCart());
      setTimeout(() => dispatch(closeCart()), 3000);
      dispatch(updateCurrency(musicCurrency));
      dispatch(totalCost());
    }
  }

  function handleAddTrackToCart(track, itemPrice) {
    if (cart.items.length && cart.currencyValue !== musicCurrency) {
      toast({
        title: 'Warning!',
        description: 'You cannot add multiple currencies in the cart',
        status: 'warning',
        position: 'bottom-left',
        duration: 100000,
        isClosable: true
      });
    } else {
      let trackPrice = Number(itemPrice[0].price);
      dispatch(addToCart({ ...track, price: trackPrice }));
      dispatch(openCart());
      setTimeout(() => dispatch(closeCart()), 3000);
      dispatch(updateCurrency(musicCurrency));
      dispatch(totalCost());
    }
  }

  function handlePlay(track) {
    dispatch(playSong(track));
    dispatch(playAlbum(res && tracks));
  }

  function handleGallery() {
    const height = newImg.height;
    const width = newImg.width;

    const image = {
      thumbnail: res.thumbnail,
      name: res.name,
      width,
      height
    };
    dispatch(openGallery(image));
  }

  function handleBuyNow() {
    dispatch(addToCart(res));
    dispatch(totalCost());
    history.push('/embed/checkout');
  }

  const availableCurrencies =
    prices &&
    prices.length &&
    prices.map(price => ({
      value: price.price_currency,
      label: currencies.find(s => s.value === price.price_currency).label
    }));

  const defaultCurrency =
    prices &&
    prices.length &&
    availableCurrencies.find(currency => currency.value === res.currency);

  function handleSetCurrency(value) {
    dispatch(setMusicCurrency(value));
  }

  return (
    <Suspense>
      <Dock
        content={
          <div style={{ padding: 14 }}>
            <Button
              color="yellow"
              width="100%"
              onClick={
                path && path.includes('embed') ? handleBuyNow : handleAddToCart
              }
            >
              {path && path.includes('embed')
                ? `Buy Album`
                : `Add ${tracks.length === 1 ? 'SINGLE' : 'ALBUM'} To Cart`}
            </Button>
          </div>
        }
      />
      <Header>
        <MetaHelmet
          title={res.name}
          description={extractContent2(`${res.description}`)}
          image={res.thumbnail}
          url={`/album/${res.slug}`}
        />
        <Container>
          <MainImage
            style={{ marginTop: 21, width: '100%', height: 300 }}
            src={res.thumbnail}
            onClick={handleGallery}
          />
          <div>
            <Title style={{ maxWidth: '100%' }}>
              <Details style={{ margin: 0 }}>
                <h3 style={{ lineHeight: 1.2 }}>{res.name}</h3>
                <h5>{res.authors[0]}</h5>
              </Details>
            </Title>
            {prices && prices.length > 1 && (
              <DropDownSelect
                defaultValue={defaultCurrency}
                style={{ width: 300, marginTop: 14 }}
                options={availableCurrencies}
                onChange={({ value }) => handleSetCurrency(value)}
              />
            )}
            <div style={{ marginTop: 14 }}>
              <h3>
                {res.currency}.{res.price}
              </h3>
              <Details
                style={{ margin: '7px 0px', textTransform: 'uppercase' }}
              >
                <h5>
                  {res.categories[0].name} {Interpunct}
                  {res.tracks.length === 1
                    ? ` SINGLE `
                    : ` ALBUM ${Interpunct} ${res.tracks.length} Songs`}
                </h5>
              </Details>
            </div>
            <p>by {res.store.name}</p>
            <SocialMedia>
              <Share>
                <DropdownMenu
                  mainTitle="Share"
                  suffixIconDown={true}
                  top={620}
                  left="20px"
                  width="200px"
                  className="dropdown"
                  menuItems={[
                    {
                      title: (
                        <FacebookShareButton
                          url={window.location.href}
                          quote={res.name}
                        >
                          Facebook
                        </FacebookShareButton>
                      ),
                      id: 'facebook'
                    },
                    {
                      title: (
                        <TwitterShareButton
                          url={window.location.href}
                          quote={res.name}
                        >
                          Twitter
                        </TwitterShareButton>
                      ),
                      id: 'twitter'
                    },
                    {
                      title: (
                        <WhatsappShareButton
                          url={window.location.href}
                          quote={res.name}
                        >
                          Whatsapp
                        </WhatsappShareButton>
                      ),
                      id: 'whatsapp'
                    }
                  ]}
                />
              </Share>
            </SocialMedia>
          </div>
        </Container>
      </Header>
      <Container>
        <TabsWrapper>
          <Tabs>
            <TabList style={{ margin: '14px 0' }}>
              <Tab>
                <h5>PURCHASE</h5>
              </Tab>
              <Tab>
                <h5>ABOUT</h5>
              </Tab>
            </TabList>
            <TabPanel>
              <Table style={{ marginBottom: 28 }}>
                <tbody>
                  {Array.isArray(res.tracks) && res.tracks.length > 0
                    ? res.tracks.map((track, idx) => {
                        const itemPrice = track.prices.filter(
                          price => price.price_currency === musicCurrency
                        );
                        return (
                          <Tr key={track.id}>
                            <Td>
                              <PlayButton onClick={() => handlePlay(track)}>
                                <span>{idx + 1}.</span>
                                <Play className="play" />
                              </PlayButton>
                            </Td>
                            <Th onClick={() => handlePlay(track)}>
                              {track.name}
                            </Th>
                            {path && !path.includes('embed') && (
                              <Td>
                                <CartButton
                                  onClick={() =>
                                    handleAddTrackToCart(track, itemPrice)
                                  }
                                >
                                  <ShoppingCart />
                                </CartButton>
                              </Td>
                            )}
                          </Tr>
                        );
                      })
                    : null}
                </tbody>
              </Table>
            </TabPanel>
            <TabPanel>
              <Description description={res.description} />
            </TabPanel>
          </Tabs>
        </TabsWrapper>
      </Container>
      {!path.includes('embed') && filteredStores.length ? (
        <MoreAlbums>
          <Container>
            <p>
              More from{' '}
              <Link to={`/store/music/${res.storeSlug}`}>
                {' '}
                {res.store.name}
              </Link>
            </p>
            <Row>
              {filteredStores.slice(0, 4).map(album => (
                <Column key={album.id}>
                  <DigitalContentCard
                    title={album.name}
                    storeName={album.store_name}
                    imgSrc={
                      album.thumbnail_frontend
                        ? album.thumbnail_frontend
                        : album.thumbnail
                    }
                    genre={album.category_name}
                    content_type={album.media_type_name}
                    to={`/album/${album.slug}`}
                  />
                </Column>
              ))}
            </Row>
          </Container>
        </MoreAlbums>
      ) : null}
    </Suspense>
  );
}

export default MobilePage;
